import { useEffect, useState } from 'react';
const resolveImageBlobUrl = async (src) => {
    const response = await fetch(src, { headers: { accept: 'image/*' }, cache: 'force-cache' });
    if (!response.ok) {
        throw new Error(`Failed to fetch image: ${response.statusText}`);
    }
    const blob = await response.blob();
    return URL.createObjectURL(blob);
};
export const useImageBlobUrl = (src) => {
    const [fetching, setFetching] = useState(false);
    const [error, setError] = useState();
    const [blobUrl, setBlobUrl] = useState();
    useEffect(() => {
        if (!src) {
            return;
        }
        let objectUrl;
        setFetching(true);
        void resolveImageBlobUrl(src)
            .then(url => {
            objectUrl = url;
            setBlobUrl(url);
        })
            .catch(error => {
            setError(error);
            objectUrl = undefined;
            setBlobUrl(undefined);
        })
            .finally(() => {
            setFetching(false);
        });
        return () => {
            setFetching(false);
            setError(undefined);
            setBlobUrl(undefined);
            if (objectUrl) {
                URL.revokeObjectURL(objectUrl);
            }
        };
    }, [src]);
    return {
        fetching,
        error,
        blobUrl,
    };
};
//# sourceMappingURL=useImageBlobUrl.js.map